import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { CommonData, LanguageSettings } from "../../../../environments/environment";
import { ApiService } from "../../../admin/api.service";
import { EnvConfigService } from '../../../env-config.service'
@Component({
  selector: "ngx-footer",
  styleUrls: ["./footer.component.scss"],
  template: `
    <div class="d-flex justify-content-end align-items-center">
        <div>
          <nb-select placeholder="{{ 'COMMON.SELECTLANGUAGE' | translate }}"  [(selected)]="selectedLang" (click)="onSelectClick()">
              <nb-option *ngFor="let option of languages" (click)="changeLang(option.indexName)" [value]="option.indexName">{{option.name}}
              </nb-option>
          </nb-select>
        </div>
        &nbsp;
        <span class="created-by float-right">
          Created by
          <b><a href="#" target="_blank">Yene</a></b>
        </span>
    </div>
  `,
})
export class FooterComponent {
  // languages = CommonData.defaultLanguage;


  selectedLang: string;
  page = 1;
  limit = 10;
  languages: any[] = [];
  hasMoreLanguages = true;
  isLoading = false;
  hasMore = true;
  constructor(
    private readonly apiservice: ApiService,
    private readonly envService: EnvConfigService,
    public translate: TranslateService) {
    const getEnvData = this.envService.getEnvData();
    const defaultSelectedLang = getEnvData?.app?.language || LanguageSettings.defaultSelectedLang
    translate.addLangs(LanguageSettings.languages);
    this.language()
    this.selectedLang = sessionStorage.getItem('language') || defaultSelectedLang;
    translate.setDefaultLang(this.selectedLang);
  }
  changeLang(lang: string): void {
    sessionStorage.setItem('language', lang)
    this.translate.use(lang);
    window.location.reload()
    // Optionally, you can do other actions upon language change here
  }
  // language() {
  //   this.apiservice.CommonGetApi('module/translation/language')
  //     .subscribe({
  //       next: (res) => {
  //         console.log(res.data.language.length)
  //         if (res.data.language.length > 0) {
  //           this.languages = res.data.language
  //         } else {
  //           this.languages = CommonData.defaultLanguage;
  //         }
  //       }
  //     })
  // }

    language() {
      if (this.isLoading || !this.hasMore) return;
    
      this.isLoading = true;
      this.apiservice.CommonGetApi(`module/translation/language?page=${this.page}&limit=${this.limit}`)
        .subscribe({
          next: (res) => {
            const newItems = res.data.language;
            if (newItems.length > 0) {
              this.languages = [...this.languages, ...newItems];
              this.page++;
            } else {
              this.hasMore = false;
            }
            this.isLoading = false;
          },
          error: () => this.isLoading = false
        });
    }
    onSelectClick() {
      setTimeout(() => {
        const panes = document.querySelectorAll('.cdk-overlay-pane');
        panes.forEach(pane => {
          const list = pane.querySelector('nb-option-list');
          if (list) {
            const scrollable = list.querySelector('ul');
            if (scrollable) {
              scrollable.addEventListener('scroll', this.onScroll);
            }
          }
        });
      }, 0);
    }

    onScroll = (event: Event) => {
    const target = event.target as HTMLElement;
    const scrollTop = target.scrollTop;
    const scrollHeight = target.scrollHeight;
    const offsetHeight = target.offsetHeight;

    // Trigger scroll end when user reaches bottom
    if (scrollTop + offsetHeight >= scrollHeight) {
      console.log('Scroll end reached');
      this.language()
    }
    };

}
